module.exports = __webpack_public_path__ + "img/Hunter-troll-m-60.1cdf1b3b.gif";